export default __webpack_public_path__ + "static/media/EXPO-SEGURIDAD-MEXICO.617303ae.png";